import { Result, DeleteData } from 'domain/types';
import DeleteAutomationClient from 'use-case/automation/delete/deleteAutomationClient';
import DeleteAutomationCriteria from 'use-case/automation/delete/deleteAutomationCriteria';

export type DeleteAutomationResult = Result<DeleteData>;
export type DeleteAutomation = (criteria: DeleteAutomationCriteria) => Promise<DeleteAutomationResult>;

export default (deleteAutomationClient: DeleteAutomationClient): DeleteAutomation => (
    criteria: DeleteAutomationCriteria
): Promise<DeleteAutomationResult> => deleteAutomationClient(criteria);
